module.exports = __webpack_public_path__ + "img/4.b1f66a52.svg";